import { render, staticRenderFns } from "./group.vue?vue&type=template&id=7406e3e4&scoped=true&"
import script from "./group.vue?vue&type=script&lang=js&"
export * from "./group.vue?vue&type=script&lang=js&"
import style0 from "./group.vue?vue&type=style&index=0&id=7406e3e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7406e3e4",
  null
  
)

export default component.exports